import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { GtmItemCategory } from '@app/domain/model/gtm/GtmItemCategory';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { ProposalCalculatedData } from '@app/domain/model/gtm/ProposalCalculatedData';
import { PremiumType } from '@app/domain/model/eshop/transport/PremiumType';

export function trackProposalCalculated(data: ProposalCalculatedData): void {
    const items: EcommerceItem[] = [];

    if (data.mtplPrice && data.mtplPrice > 0) {
        items.push({
            item_name: PremiumType.Mtpl,
            item_id: GtmItemCategory.Mtpl,
            price: data.mtplPrice,
            item_category: GtmItemCategory.TransportInsurance,
            item_variant: data.insurancePackage,
            quantity: 1,
        });
    }

    if (data.cascoPrice && data.cascoPrice > 0) {
        items.push({
            item_name: PremiumType.Casco,
            item_id: GtmItemCategory.Casco,
            price: data.cascoPrice,
            item_category: GtmItemCategory.TransportInsurance,
            item_variant: data.insurancePackage,
            quantity: 1,
        });
    }

    pushEcommerceEvent(GtmEventName.ProposalCalculated, {
        currency: 'EUR',
        value: data.totalPrice,
        items,
    });
}
